module.exports = __webpack_public_path__ + "static/img/图层 26.89cf50be.png";